<template>
  <div class="flex flex--column flex--center">
    <div class="content color--primaryDark font--s16">
      <article id="d2ff8f2b-7688-4ec5-b90b-fadb2913bdd8" class="page sans">
        <header><h1 class="page-title">Datenschutzerklärung</h1></header>
        <div class="page-body">
          <p id="de28a1aa-025d-4d82-aa8e-e2ac6610da3e" class="">
            <strong>Wir</strong> als Anbieter der App
            „<strong>Doguniversity</strong>“ (auch „<strong>App</strong>“) sind
            <strong>Verantwortliche</strong> im Sinne des geltenden
            Datenschutzrechts, insbesondere der Datenschutz-Grundverordnung
            („DSGVO“), für die personenbezogenen Daten der Nutzer*in
            („<strong>Sie</strong>“) dieser App.
          </p>
          <p id="49906342-cf42-4486-b2e5-de254f781d77" class="">
            Im Folgenden unterrichten wir Sie übersichtlich im Rahmen unserer
            Informationspflichten (Art. 13 ff. DSGVO) darüber, welche Daten bei
            Nutzung unserer App verarbeitet werden und auf welcher
            Rechtsgrundlage dies geschieht. Sie erhalten außerdem Informationen
            darüber, welche Rechte Sie gegenüber uns und gegenüber der
            zuständigen Aufsichtsbehörde haben.
          </p>
          <h2>1. Informationen zum Verantwortlichen</h2>
          <p id="0df24e06-9d3f-4996-a443-3e75edc75b6a" class="">
            Name und Kontaktdaten:
          </p>
          <p id="edbe07ba-6b86-4165-a1ea-988597a6b7a4" class="">
            Doguniversity GmbH
          </p>
          <p id="228d1adc-598d-4f10-a8bf-be70a624e36c" class="">
            Nathlandstraße 79
          </p>
          <p id="a3bc07bb-1008-4e92-8332-e571bf2fee6f" class="">
            46047 Oberhausen
          </p>
          <p id="1082eaeb-9e31-4407-811e-ef162a5365a7" class="">
            E-Mail: info@doguniversity.de
          </p>
          <h2>
            2. Allgemeine Hinweise
          </h2>
          <p id="3d460189-abb9-41d5-814b-893933039f6f" class="">
            Wenn wir nachfolgend von „<strong>Smartphone</strong>“ sprechen,
            meinen wir jedes mobile Endgerät, auf dem unsere App verwendet
            werden kann.
          </p>
          <h2>3. Herunterladen der App</h2>
          <p id="5b6e921d-60a2-409e-b4ca-8d304e5303b9" class="">
            Sie können unsere App aus einem App-Store Ihrer Wahl (Apple App
            Store oder Google Play Store) auf Ihr Smartphone herunterladen.
            Falls Sie über unsere Website den Download-Link anklicken, werden
            Sie direkt auf unseren Store-Eintrag im jeweiligen App-Store
            geleitet, um die App zu installieren.
          </p>
          <p id="d377cdf9-8998-4d96-8cee-7b6fb9be306d" class="">
            Beim Herunterladen der App auf Ihr Smartphone werden die dafür
            notwendigen Informationen, also insbesondere Nutzername,
            E-Mail-Adresse und Kundennummer Ihres App-Store-Accounts, Zeitpunkt
            des Downloads, Zahlungsinformationen und die individuelle
            Gerätekennziffer, an den jeweiligen App Store (Apple App Store oder
            Google Play Store) übertragen.
          </p>
          <p id="3988615c-4911-455a-b04b-0c4489b7b421" class="">
            Auf diese Datenerhebung haben wir jedoch keinen Einfluss und sind
            nicht dafür verantwortlich. Wir verarbeiten diese bereitgestellten
            Daten, soweit dies für das Herunterladen der App auf Ihr Smartphone
            notwendig ist. Diese Daten werden darüber hinaus nicht weiter
            gespeichert. Rechtsgrundlage für diese Datenverarbeitung ist Art. 6
            Abs. 1 Satz 1 lit. f DSGVO, da es unserem berechtigten Interesse
            entspricht, die für den Download und Installation erforderlichen
            Daten zu verarbeiten, um Ihnen eine Nutzung der App zu ermöglichen.
          </p>
          <h2>4. Zurverfügungstellung der Funktionen unserer App</h2>
          <p id="77663ac7-2ab3-473d-b6ad-820e9bd9ee15" class="">
            Während der Nutzung der App wird eine Internetverbindung aufgebaut.
            Dabei erheben wir personenbezogenen Daten in Form von sogenannten
            Logfiles von Ihnen. Die Verarbeitung dieser personenbezogenen Daten
            ist für uns technisch erforderlich, um Ihnen die Funktionen unserer
            App komfortabel zur Verfügung zu stellen und um die Stabilität und
            Sicherheit unserer informationstechnischen Systeme zu gewährleisten.
            Folgende Daten, die personenbezogen sein können, werden dabei
            verarbeitet:
          </p>
          <ul id="c8ddc253-d70b-4e75-9cfb-8cb267c03f77" class="bulleted-list">
            <li style="list-style-type: disc">IP-Adresse</li>
          </ul>
          <ul id="2e16c0c2-c6aa-4384-8e04-5f50258ae13c" class="bulleted-list">
            <li style="list-style-type: disc">
              Informationen über den Browser
            </li>
          </ul>
          <ul id="1e6e7cea-835c-4e48-ac7c-a43280653bec" class="bulleted-list">
            <li style="list-style-type: disc">
              Zeitzonendifferenz zur Greenwich Mean Time (GMT)
            </li>
          </ul>
          <ul id="857c51ca-4b30-451f-9c7d-9a9f8790a0b1" class="bulleted-list">
            <li style="list-style-type: disc">Übertragene Datenmenge</li>
          </ul>
          <ul id="588180f4-6d29-4849-a920-fd3bb865865c" class="bulleted-list">
            <li style="list-style-type: disc">Besuchte Domain</li>
          </ul>
          <ul id="fc47498f-90e9-45c1-8b4b-96ddbb5e0a15" class="bulleted-list">
            <li style="list-style-type: disc">
              Datum und Uhrzeit des App-Zugriffs
            </li>
          </ul>
          <ul id="37a3ddab-43cf-4490-9b0a-e5b9cde4a8c7" class="bulleted-list">
            <li style="list-style-type: disc">
              Zugriffsstatus (Datei übertragen, Datei nicht gefunden, etc.)
            </li>
          </ul>
          <ul id="8059323e-6a3c-4931-9df2-8a10492a0382" class="bulleted-list">
            <li style="list-style-type: disc">
              Seite, von der aus die Datei angefordert wurde / Referrer
            </li>
          </ul>
          <ul id="fb7f4f30-0dba-435c-b7a4-e8c6d0359bfb" class="bulleted-list">
            <li style="list-style-type: disc">Gerätehersteller und Name</li>
          </ul>
          <ul id="f73c7f38-a823-46e5-a3e3-e8f16cb3495e" class="bulleted-list">
            <li style="list-style-type: disc">Betriebssystem und Version</li>
          </ul>
          <ul id="bfbb19ef-2088-4b26-9921-14f875b9c136" class="bulleted-list">
            <li style="list-style-type: disc">Appversion</li>
          </ul>
          <p id="371ee562-157a-4806-8f4e-93dedb750e06" class="">
            Für die Bereitstellung unserer App ist die Verarbeitung der oben
            genannten Daten erforderlich. Wir speichern die Daten auch zum
            Zwecke der Sicherheit unserer informationstechnischen Systeme. In
            diesen Zwecken ist auch unser berechtigtes Interesse begründet, die
            Daten auf der <strong>Rechtsgrundlage</strong> Art. 6 Abs. 1 Satz 1
            lit. f DSGVO zu verarbeiten.
          </p>
          <p id="c241870d-1619-451c-86e4-974228c3596c" class="">
            Eine Zuordnung der Daten zu Ihnen und damit die Herstellung des
            Personenbezugs ist grundsätzlich möglich. Wir speichern Ihre Daten
            jedoch nur vorübergehend. Sie werden unverzüglich gelöscht oder
            anonymisiert, nachdem sie zur Erreichung der vorgenannten Zwecke
            nicht mehr erforderlich sind. Die IP-Adresse wird spätestens nach
            sieben Tagen gelöscht.
          </p>

          <h2>5. Kundenkonto</h2>
          <p id="3b2ec47b-fd0f-455a-ac3d-6ae31e0edf82" class="">
            Sie müssen sich für die Nutzung unserer App bei uns anmelden oder
            neu registrieren. Folgende Daten fragen wir für die Anmeldung oder
            Registrierung ab:
          </p>
          <ul id="223875db-0197-485a-9b82-a056aef7cb32" class="bulleted-list">
            <li style="list-style-type: disc">Anzahl der Hunde (freiwillig)</li>
          </ul>
          <ul id="4c1fdd17-05b9-4a05-a31d-9ef156de9d4f" class="bulleted-list">
            <li style="list-style-type: disc">Vor- und Nachname</li>
          </ul>
          <ul id="63645c9c-0d1b-4c66-a4f3-958dfe6a3dd4" class="bulleted-list">
            <li style="list-style-type: disc">E-Mail-Adresse</li>
          </ul>
          <ul id="78523056-047e-4d80-a7f1-6e539f851685" class="bulleted-list">
            <li style="list-style-type: disc">Geschlecht (m/w/divers)</li>
          </ul>
          <ul id="2d495fd6-cdcf-4587-87ad-1c83a4186033" class="bulleted-list">
            <li style="list-style-type: disc">Passwort</li>
          </ul>
          <ul id="6f9add88-75d0-4bcb-b9d8-2eefbf533f3e" class="bulleted-list">
            <li style="list-style-type: disc">
              Heimatstadt (Auswahloption; keine automatisierte Abfrage)
            </li>
          </ul>
          <p id="8a21b900-24a8-45d3-a6f1-2da3a89ab722" class="">
            Freiwillig können Sie nach erfolgter Anmeldung folgende zusätzliche
            Daten hinterlegen:
          </p>
          <ul id="78e2e16b-3718-4601-9f93-03845084f778" class="bulleted-list">
            <li style="list-style-type: disc">Profilbild</li>
          </ul>
          <ul id="06e23747-dd42-4394-8708-8803beb46b5b" class="bulleted-list">
            <li style="list-style-type: disc">
              Persönliche Interessen (mit Bezug zu Hunden und Hundetraining,
              Auswahlmöglichkeiten)
            </li>
          </ul>
          <ul id="7678159e-94a4-4a66-b129-8135db64b219" class="bulleted-list">
            <li style="list-style-type: disc">
              Sonstige Informationen zu Ihrem Hund (z.B. Hundename, Hunderasse,
              Geschlecht, Geburtsdatum, Informationen über die
              Ausbildung/Trainingsfortschritte, Informationen zur Futterberatung
              (Gewicht des Hundes, Körperzustand des Hundes, Impfungen,
              Medikamente, Entwurmung, Läufigkeit, Hundeakte), Persönlichkeit
              des Hundes, Hundepass, Hundefamilie
            </li>
          </ul>
          <p id="be2510c2-a2c1-40b4-8589-49f886745f04" class="">
            Community/Forum
          </p>
          <ul id="fe8f6da9-f87d-404f-8a6a-04f736e0e453" class="bulleted-list">
            <li style="list-style-type: disc">
              Sie können außerdem Beiträge und Fotos mit der Community teilen
              (Titel, Beschreibung, Thema, Bild)
            </li>
          </ul>
          <p id="e23deaac-0d3d-4fea-b4c9-3688596e486e" class="">
            Ihre Daten werden zum Zwecke der Verwaltung Ihres Kundenkontos und
            Bereitstellung der damit verbundenen Funktionen, wie z.B.
            Kursteilnahme, Dokumentation zu Ihren Hunden, Teilhabe an der
            Community, verarbeitet. Die <strong>Rechtsgrundlage</strong> für die
            Speicherung Ihrer Kundenkonto-Daten ist Art. 6 Abs. 1 Satz 1 lit. b
            DSGVO.
          </p>
          <p id="d3aaa5cc-9584-42dd-ae35-bbabd960b399" class="">
            Wir verarbeiten Ihre Daten über die App, solange Sie Ihr Kundekonto
            bei uns nicht löschen. Sie können jederzeit einen Antrag auf
            Löschung Ihres Kontos bei uns (z.B. per E-Mail an die in Ziffer 1
            genannte E-Mail-Adresse) stellen. Viele Inhalte Ihres Kundenkontos
            können Sie in der App selbst ändern oder löschen.
          </p>
          <p id="6be57fd9-c9a3-495c-a6c8-70f80b99de0c" class="">
            Darüberhinausgehend speichern wir Ihre Daten nur, um unseren
            vertraglichen oder gesetzlichen Verpflichtungen (z.B. steuerlichen
            Pflichten) nachzukommen (Art. 6 Abs. 1 Satz 1 lit. c DSGVO). In
            diesem Fall sperren wir Ihre Daten insoweit, als dass sie nur noch
            für die notwendigen Zwecke verarbeitet werden.
          </p>
          <h2>6. Versand und Empfang von (Direkt-)Nachrichten</h2>
          <p id="42f053b4-bfe9-4244-9db6-c9f97ea7047f" class="">
            Unsere App bietet Ihnen die Möglichkeit, Direktnachrichten zu senden
            und zu empfangen. Auf diesem Weg können Sie mit anderen
            registrierten App-Nutzern kommunizieren und zu verschiedenen Themen
            austauschen. Damit ermöglichen wir Ihnen eine vollständige Nutzung
            sämtlicher Funktionen der App. Rechtsgrundlage für die
            Datenverarbeitung ist Art. 6 Abs. 1 S. 1 lit. b DSGVO.
          </p>
          <p id="c0c275a3-8bb6-4c0b-bd81-b4fd86044a64" class="">
            Solange Ihr Profil aktiv ist, sind auch die von Ihnen versendeten
            Nachrichten bei uns gespeichert. Wenn Sie Ihr Profil löschen, wird
            Ihr Name im Nachrichtenverlauf anonymisiert; die Nachrichteninhalte
            bleiben für den Empfänger jedoch erhalten.
          </p>

          <h2>7. Nutzung des App-Forums</h2>
          <p id="b2952f68-cf84-4599-a9cf-995514e54291" class="">
            Über unsere App können Sie unser Forum nutzen. Im Forum können Sie
            Beiträge verfassen, die von anderen registrierten App-Nutzern
            gelesen und durch einen weiteren Beitrag beantwortet werden können.
            Auf diesem Weg können Sie mit anderen registrierten Nutzern
            kommunizieren und zu verschiedenen Themen austauschen.
            Rechtsgrundlage für die Datenverarbeitung ist Art. 6 Abs. 1 S. 1
            lit. b DSGVO.
          </p>
          <p id="1998b3db-06e3-4522-98a2-4c0483d847c3" class="">
            Solange Ihr Profil aktiv ist, sind auch die von Ihnen bei der
            Nutzung des Forums veröffentlichten Inhalte bei uns gespeichert.
            Wenn Sie Ihr Profil löschen, werden auch Ihre Beiträge im Forum
            gelöscht.
          </p>

          <h2>8. Webversion des Forums</h2>
          <p id="d82cbc44-94f7-4dcc-beb2-1f0ee8a8def0" class="">
            Das Forum unserer App (einschließlich der veröffentlichten Beiträge,
            Bilder und sonstigen Informationen) wird auf unserer Website unter
            <a href="https://forum.doguniversity.app/"
              >https://forum.doguniversity.app</a
            >
            abgebildet und auch nicht registrierten Nutzern zugänglich gemacht.
            Wir „blurren“ dabei die Fotos und kürzen die Nachnamen registrierter
            Forumsteilnehmer, um den Schutz personenbezogener Daten zu erhöhen.
            Sofern in den von Ihnen verfassten Beiträgen, Bildern und sonstigen
            im Forum kommunizierten Informationen auch personenbezogene Daten
            enthalten sind, werden diese Daten damit Dritten (nicht
            registrierten Forumsbesuchern) im Internet zugänglich gemacht. Diese
            Verarbeitung Ihrer personenbezogenen Daten erfolgt in unserem
            berechtigten Interesse, die Reichweite der App und des Forums zu
            stärken und Informationen über Hundetraining, Hundegesundheit und
            mehr einer breiteren Öffentlichkeit zugänglich zu machen.
            Rechtsgrundlage hierfür ist Art. 6 Abs. 1 S. 1 lit. f DSGVO.
          </p>
          <p id="e1418f39-8469-45b3-8420-ea48f4ba732b" class="">
            Solange Ihr Profil aktiv ist, sind auch die von Ihnen bei der
            Nutzung des Forums veröffentlichten Inhalte bei uns gespeichert.
            Wenn Sie Ihr Profil löschen, werden auch Ihre Beiträge im Forum
            gelöscht.
          </p>

          <h2>9. Versand von E-Mails</h2>
          <p id="457ba9ed-d8a0-4fa2-94cd-b2880310f4cc" class="">
            Zum automatisierten Versand von System E-Mails seitens unserer App
            wie beispielsweise dem Verifizierungscode, nutzen wir den „Amazon
            Simple Email Service“ von Amazon AWS (Amazon Web Services Inc., 410
            Terry Avenue North, Seattle, WA 98109-5210, USA). Zum Zwecke des
            E-Mail-Versands werden die E-Mail-Adressen der Nutzer temporär
            (während des Versandes) an einen Server der AWS innerhalb
            Deutschlands übermittelt. Die an AWS übermittelten Daten werden auf
            den Servern so lange gespeichert, bis wir diese löschen.
          </p>
          <p id="20da8bd7-1b7f-48d5-b5f1-981ab45614a7" class="">
            Wir haben mit AWS einen Auftragsdatenverarbeitungsvertrag
            abgeschlossen, welcher die EU-Standardvertragsklauseln enthält. Sie
            können das Data Processing Addendum inkl. der
            Standardvertragsklauseln abrufen unter:
            <a href="https://d1.awsstatic.com/legal/aws-gdpr/AWS_GDPR_DPA.pdf"
              >https://d1.awsstatic.com/legal/aws-gdpr/AWS_GDPR_DPA.pdf</a
            >.
          </p>
          <p id="92a17c6a-8864-49e4-83e9-de6cdd275947" class="">
            Nähere Informationen zu Amazon Simple Email Service, AWS und zum
            Datenschutz finden Sie unter
            <a href="https://aws.amazon.com/de/ses/"
              >https://aws.amazon.com/de/ses/</a
            >
            sowie unter (<a
              href="https://aws.amazon.com/de/compliance/privacy-features/"
              >https://aws.amazon.com/de/compliance/privacy-features/</a
            >).
          </p>

          <h2>10. Bestellungen</h2>
          <p id="ec3bf079-93f7-435f-bcc5-a3c5f25f8519" class="">
            Kauf und Bezahlung der Kurse, die wir auf unserer Website und in der
            App anbieten, werden über die Digistore24 GmbH, St.-Godehard-Str.
            32, 31139 Hildesheim (nachfolgend: Digistore24) abgeschlossen und
            abgewickelt. Angezeigt werden Sie in unserer App per „Webview“.
            Rechtsgrundlage für die Übermittlungen Ihrer IP-Adresse bei der
            Einbindung des Digistore24 ist Art. 6 Abs. 1 Satz 1 lit. f DSGVO, da
            es unserem berechtigten Interesse entspricht, für die Bereitstellung
            unserer kostenpflichtigen Dienste einen Dienstleister einzubinden.
          </p>
          <p id="9aafd8d7-b830-4cd6-b88a-e11ff72631ce" class="">
            Für alle im Rahmen mit der Kaufabwicklung zu verarbeitenden Daten
            ist Digistore24 verantwortlich. Wir erhalten diese Daten nicht.
          </p>
          <h2>11. Berechtigungen</h2>
          <p id="28f83b2c-3be9-41b7-910f-59bed13dad7d" class="">
            Für einige Funktionen der App sind bestimmte Zugriffe auf Funktionen
            Ihres Smartphones durch die App erforderlich. Die Funktionen
            unterscheiden sich, je nachdem ob Sie die App aus dem Apple App
            Store oder Google Play Store herunterladen. Im Folgenden finden Sie
            die Übersicht der jeweiligen Berechtigungen:
          </p>
          <p id="6dc1fa75-2214-42f1-b18f-6d2bdd091c27" class="">
            Die <strong>Android-App</strong> fordert folgende Berechtigungen an
            (in den Android-Einstellungen können Sie unter „Einstellungen“ -
            „Apps &amp; Benachrichtigungen“ - „App-Berechtigungen“ die
            Berechtigung unserer App jederzeit deaktivieren):
          </p>
          <p id="6af051ff-c388-4bea-b97e-adfc9d0faf52" class="">
            <strong>Internet: </strong>Erforderlich, um eine Kommunikation mit
            den Doguniversity-Servern zu ermöglichen; bspw. um Kurse
            bereitzustellen oder neue Inhalte aus der Community zu laden.
          </p>
          <p id="847317f0-35c5-4df2-94a4-793714264976" class="">
            <strong>Kamera/Fotos: </strong>Die Berechtigung wird abgefragt, wenn
            Sie ein Foto hochladen oder über Ihre Kamera aufnehmen möchten
            (bitte beachten Sie: wenn Sie ein Foto hochladen, wird auch der
            Zeitpunkt und Standort erfasst).
          </p>
          <p id="eb3c0e33-0b31-4a3a-a852-b1179c92689b" class="">
            <strong
              >Push-Nachrichten (per Google Firebase Cloud Messaging)</strong
            >: Wenn Sie unsere App erstmalig öffnen, werden Sie gefragt, ob sie
            Push-Nachrichten von uns erhalten möchten. Dies dient beispielsweise
            dazu, Ihnen automatische Gefahrenmeldungen aus Ihrer Umgebung zu
            schicken
          </p>
          <p id="facbf96f-f3f7-4039-b769-762b2cb42002" class="">
            <strong>Medien/Dateien/Galerie: </strong>Wir greifen mit Ihrer
            Zustimmung auf Dateien Ihres Smartphones zu (z.B. um ein Profilbild
            hochzuladen oder Dateianhänge zu ermöglichen).
          </p>
          <p id="3b686458-8dd5-4241-8210-bae69f97f4ce" class="">
            <strong>Standort:</strong> Die App benötigt diese Funktion, um auf
            der Karte die Position des Nutzers anzeigen zu können. Des Weiteren
            um die Entfernung zu anderen Nutzern aus der App zu berechnen. Der
            Standort wird nur abgefragt, wenn die App vom Nutzer auch gerade
            genutzt wird.
          </p>
          <p id="a844eb66-6ef5-4cae-ba55-7076a312c37c" class="">
            Die <strong>iOS-App</strong> fordert folgende Berechtigungen an (in
            den iOS-Einstellungen können Sie unter „Einstellungen“ -
            „Datenschutz“ - z.B. „Fotos“ die Berechtigung unserer App jederzeit
            deaktivieren):
          </p>
          <p id="1b5d92f5-fc20-4dc4-bb27-65fb7b340fe1" class="">
            <strong>Internet: </strong>Erforderlich, um eine Kommunikation mit
            den Doguniversity-Servern zu ermöglichen; bspw. um Kurse
            bereitzustellen oder neue Inhalte aus der Community zu laden.
          </p>
          <p id="baa4900a-3229-4696-b34f-960a3905e481" class="">
            <strong>Fotos</strong>: Die Berechtigung wird abgefragt, wenn Sie
            ein Foto hochladen möchten (bitte beachten Sie: wenn Sie ein Foto
            hochladen, wird auch der Zeitpunkt und Standort erfasst).
          </p>
          <p id="210abc45-da52-4163-910a-a10f5d662974" class="">
            <strong>Kamera</strong>: Die Berechtigung wird abgefragt, wenn Sie
            ein Profilbild über Ihre Kamera aufnehmen möchten.
          </p>
          <p id="daac667d-ad21-4825-8521-9273b1bbfdb3" class="">
            <strong
              >Push-Nachrichten (per Google Firebase Cloud Messaging)</strong
            >: Wenn Sie unsere App erstmalig öffnen, werden Sie gefragt, ob sie
            Push-Nachrichten von uns erhalten möchten. Dies dient beispielsweise
            dazu, Ihnen automatische Gefahrenmeldungen aus Ihrer Umgebung zu
            schicken.
          </p>
          <p id="8210e802-e322-4709-b5db-d5412bbadf8f" class="">
            <strong>Medien/Dateien/Galerie: </strong>Wir greifen mit Ihrer
            Zustimmung auf Dateien Ihres Smartphones zu (z.B. um ein Profilbild
            hochzuladen oder Dateianhänge zu ermöglichen).
          </p>
          <p id="f36267d9-8c99-4464-819e-e246f22ababf" class="">
            <strong>Standort:</strong> Die App benötigt diese Funktion, um auf
            der Karte die Position des Nutzers anzeigen zu können. Des Weiteren
            um die Entfernung zu anderen Nutzern aus der App zu berechnen. Der
            Standort wird nur abgefragt, wenn die App vom Nutzer auch gerade
            genutzt wird.
          </p>
          <p id="1dbad1cb-ae00-470b-8e09-1e6c4677d050" class="">
            Rechtsgrundlage für die Datenverarbeitung ist Art. 6 Abs. 1 Satz 1
            lit. a DSGVO. Sie können auf Ihrem Smartphone selbst steuern, ob Sie
            uns die Berechtigung erteilen oder wieder entziehen möchten. Durch
            die Berechtigungen werden keine (zusätzlichen) personenbezogenen
            Daten dauerhaft gespeichert.
          </p>
          <h2>12. Kontaktaufnahme per E-Mail oder Telefon</h2>
          <p id="f2e9f86f-d2c7-4619-a5f0-e821d2820a9d" class="">
            Sie haben die Möglichkeit, uns per
            <strong>E-Mail oder Telefon</strong> zu kontaktieren. Ihre auf
            diesem Wege übermittelten personenbezogenen Daten werden bei uns
            gespeichert. Die Daten werden ausschließlich verarbeitet, um Ihre
            Kontaktaufnahme zu bearbeiten. Die
            <strong>Rechtsgrundlage</strong> für die Verarbeitung Ihrer
            personenbezogenen Daten ist Art. 6 Abs. 1 Satz 1 lit. f DSGVO. Die
            Daten werden gespeichert, bis sie zur Erreichung des Zwecks der
            Konversation mit Ihnen nicht mehr erforderlich sind und das Anliegen
            Ihrer Kontaktaufnahme umfassend geklärt ist.
          </p>
          <p id="40f8b14f-d62a-4af4-b44a-aa67d716abf7" class="">
            Wenn Ihre Kontaktaufnahme darauf abzielt, einen Vertrag mit uns
            abzuschließen, ist die zusätzliche
            <strong>Rechtsgrundlage</strong> für die Verarbeitung Ihrer
            personenbezogenen Daten Art. 6 Abs. 1 Satz 1 lit. b DSGVO. Diese
            Daten werden so lange gespeichert, wie sie zur Durchführung des
            Vertrags erforderlich sind. Darüberhinausgehend speichern wir Ihre
            Daten nur, um vertraglichen oder gesetzlichen Verpflichtungen (z.B.
            steuerlichen Pflichten) nachzukommen (Art. 6 Abs. 1 Satz 1 lit. c
            DSGVO).
          </p>
          <p id="58bd5de9-84a6-4bb3-a15a-4814d1910cfe" class="">
            Zusätzlich zu den Daten, die Sie uns freiwillig mitteilen, erhalten
            wir ggf. automatisiert den Zeitpunkt (Datum und Uhrzeit) der
            Übermittlung Ihrer Daten an uns, die der Nachricht zugehörige
            Message-ID sowie Kennungen jedes Servers, der an der Übermittlung
            der E-Mail von Sender zum Empfänger durch Weiterleitung beteiligt
            war. Die Verarbeitung dieser Daten entspricht unserem berechtigten
            Interesse (Art. 6 Abs. 1 Satz lit. f DSGVO), um die Sicherheit
            unserer Systeme zu gewährleisten und Missbrauch entgegenzuwirken.
            Diese Daten, die wir während Ihrer Kontaktaufnahme zusätzlich
            erheben, werden gelöscht, sobald sie nicht mehr benötigt werden,
            spätestens wenn das Anliegen Ihrer Kontaktaufnahme umfassend geklärt
            ist.
          </p>
          <p id="5c4a6ede-f7fb-4a65-9891-7f40ed0c2814" class="">
            Sie können uns jederzeit mitteilen (siehe oben Ziffer 1), dass wir
            die im Rahmen der Konversation mitgeteilten Daten löschen sollen. In
            diesem Fall werden, soweit zulässig, alle personenbezogenen Daten
            der Konversation gelöscht und eine Fortführung der Konversation ist
            nicht möglich.
          </p>
          <h2>13. Eingebundene Dienste</h2>
          <p id="f16cdd1d-b1c3-4449-b3dc-bb6cf80c2040" class="">
            Um unsere App ansprechend zu gestalten und Ihnen alle Funktionen zur
            Verfügung zu stellen, binden wir Dienste von Drittanbietern in
            unsere App ein.
          </p>
          <ol
            type="1"
            id="01bd1508-4572-46c6-bb35-5d4cc2e16a61"
            class="numbered-list"
            start="1"
          >
            <li><strong>Kursverwaltung mit Okourse</strong></li>
          </ol>
          <p id="998b0e53-c826-48bd-bb26-b99a11147123" class="">
            Wir setzen für unsere Onlinekurs-Verwaltung den Dienstleister
            Okourse der NEON Software Solutions GmbH, Burgsdorfstr. 5, 13353
            Berlin, Deutschland (nachfolgend: <strong>Okourse</strong>), ein.
            Okourse unterstützt uns dabei, Videos, Textinhalte und
            Lernkontrollen zu erfassen.
          </p>
          <p id="26da1b6b-0aaf-4481-94e8-4b224e4ca0df" class="">
            Rechtsgrundlage für die Einbindung und Datenübermittlung an Okourse
            ist Art. 6 Abs. 1 S. 1 lit. f DSGVO, da es unserem berechtigten
            Interesse entspricht, bei der Bereitstellung unserer Dienste externe
            Hilfe in Anspruch zu nehmen.
          </p>
          <p id="fedc790a-c7f7-42d7-97dc-76ed71635ab6" class="">
            Datenschutzinformationen von Okourse finden Sie unter:
            <a href="https://okourse.com/data">https://okourse.com/data</a>
          </p>
          <ol
            type="1"
            id="9a3f2d0a-1b07-48c6-a658-a031af9471e5"
            class="numbered-list"
            start="2"
          >
            <li><strong>Videodienst Vimeo</strong></li>
          </ol>
          <p id="9c9024ed-4e17-4783-a2cd-2cdf5b0d0ede" class="">
            Unsere App nutzt das Videoportal Vimeo. Anbieter ist die Vimeo Inc.,
            555 West 18th Street, New York, New York 10011, USA. Wenn Sie eine
            unserer mit Vimeo-Videos ausgestatteten Seiten besuchen, wird eine
            Verbindung zu den Servern von Vimeo hergestellt. Dabei wird dem
            Vimeo-Server mitgeteilt, welche unserer Seiten Sie besucht haben.
            Zudem erlangt Vimeo Ihre IP-Adresse. Wir haben Vimeo jedoch so
            eingestellt, dass Vimeo Ihre Nutzeraktivitäten nicht nachverfolgen
            und keine Cookies setzen wird. Die Nutzung von Vimeo erfolgt im
            Interesse einer ansprechenden Darstellung unserer Online-Angebote.
          </p>
          <p id="84511c47-28a0-4f46-bc98-e1c2bf706933" class="">
            Dies stellt ein berechtigtes Interesse im Sinne des Art. 6 Abs. 1
            lit. f DSGVO dar. Sofern eine entsprechende Einwilligung abgefragt
            wurde, erfolgt die Verarbeitung ausschließlich auf Grundlage von
            Art. 6 Abs. 1 lit. A DSGVO; die Einwilligung ist jederzeit
            widerrufbar.
          </p>
          <p id="110723e2-e197-4da3-8e95-e105e9af6c03" class="">
            Die Datenübertragung in die USA wird auf die
            Standardvertragsklauseln der EU-Kommission sowie nach Aussage von
            Vimeo auf „berechtigte Geschäftsinteressen“ gestützt. Details finden
            Sie hier:
          </p>
          <p id="b92c7589-1b23-4c54-bb4d-194b6b8047a1" class="">
            <a href="https://vimeo.com/privacy">https://vimeo.com/privacy</a>.
          </p>
          <p id="75da1f2b-721d-4259-bb0a-e039965175f4" class="">
            Weitere Informationen zum Umgang mit Nutzerdaten finden Sie in der
            Datenschutzerklärung von Vimeo unter:
            <a href="https://vimeo.com/privacy">https://vimeo.com/privacy</a>.
          </p>
          <ol
            type="1"
            id="d5c822c2-86b8-4183-a89f-60bda7b118ca"
            class="numbered-list"
            start="3"
          >
            <li><strong>Videodienst YouTube</strong></li>
          </ol>
          <p id="7cbea020-58b6-450e-a96f-71994b73dbc7" class="">
            Unsere App nutzt das Videoportal YouTube. Anbieter ist die Google
            LLC, 1600 Amphitheatre Parkway Mountain View, CA 94043, USA (im
            Folgenden „<strong>YouTube</strong>“). Wir verwenden bei der
            Einbindung den erweiterten Datenschutzmodus, sodass Daten über Sie
            mit YouTube nur geteilt werden, wenn Sie durch Anklicken des
            Abspielbuttons des Videos das Video aktivieren.
          </p>
          <p id="8dc03974-3ac4-485b-b5a5-e0d349c36957" class="">
            Wenn Sie das Video aktivieren, setzt YouTube zum Sammeln von
            Informationen Cookies ein, die für Analysezwecke und zur
            Verbesserung der Nutzerfreundlichkeit ausgewertet werden. Wenn Sie
            gleichzeitig bei einem Google-Dienst angemeldet sind, kann es sein,
            dass Google die Cookie-Informationen mit weiteren Informationen über
            Sie zusammenfügt.
          </p>
          <p id="15d68830-9424-43a7-af04-3cd0c4992431" class="">
            Weitere Informationen zum Datenschutz, auch zur Speicherdauer Ihrer
            Daten bei YouTube, finden Sie unter:
            <a href="https://policies.google.com/privacy?hl=de"
              >https://policies.google.com/privacy?hl=de</a
            >.
          </p>
          <p id="564d8aaf-d64e-4412-be05-dedf0b952469" class="">
            Die Rechtsgrundlage für die Einbindung von YouTube und hiermit
            zusammenhängende Übermittlung Ihrer Daten an YouTube ist Art. 6 Abs.
            1 S. 1 lit. f DSGVO. Es entspricht unserem berechtigten Interesse,
            zur verbesserten und anschaulichen Verwendung unserer App, den
            Dienstleister einzubinden.
          </p>
          <p id="76a3fc3e-dde1-495c-899e-38b7affb6b96" class="">
            YouTube stützt sich für die Datenübermittlung in Drittländer auf die
            Standardvertragsklauseln. Mehr Informationen hierzu finden Sie
            unter:
            <a href="https://policies.google.com/privacy/frameworks?hl=de"
              >https://policies.google.com/privacy/frameworks?hl=de</a
            >.
          </p>
          <ol
            type="1"
            id="eeca92af-cafc-4ad8-b40d-821fdec2707f"
            class="numbered-list"
            start="4"
          >
            <li><strong>Typeform</strong></li>
          </ol>
          <p id="5cffcbb4-1a9a-4edf-9451-7aeeffe06cdc" class="">
            In unserer App verwenden wir den Dienst Typeform der Typeform SL
            C/Bac de Roda, 163 (Local), 08018 – Barcelona, Spanien (nachfolgend:
            <strong>Typeform</strong>). Über Typeform fragen wir bestimmte
            Informationen ab (z.B. Fragen zu Ihrer Person/Ihrem Hund, um Ihr
            Profil zu ergänzen). Wir nutzen Typeform auch, um Umfragen zu
            machen, Fehler der App zu melden oder um Futterberatungstermine zu
            vereinbaren.
          </p>
          <p id="c306068b-4a50-425e-a526-367d2cc4f2b0" class="">
            Die Daten speichern wir jeweils nur so lange, wie sie für die Zwecke
            (Auswertung von Umfragen; Terminvereinbarungen, etc.) erforderlich
            sind.
          </p>
          <p id="acb3d307-6398-40f9-83b3-28154dff9a3a" class="">
            Rechtsgrundlage für die Einbindung von Typeform und ggf.
            Übermittlung Ihrer Daten an Typeform ist Art. 6 Abs. 1 S. 1 lit. f
            DSGVO. Es entspricht unserem berechtigten Interesse, zur
            verbesserten und anschaulichen Bedienbarkeit unserer App, den
            europäischen Dienstleister einzubinden.
          </p>
          <p id="d7e95f94-1e96-4a67-a72d-8a4b9431b169" class="">
            Weitere Datenschutzinformationen zu Typeform finden Sie unter:
            <a href="https://admin.typeform.com/to/dwk6gt/"
              >https://admin.typeform.com/to/dwk6gt/</a
            >.
          </p>
          <ol
            type="1"
            id="05b50387-2088-401b-85cb-8a4eeb996778"
            class="numbered-list"
            start="5"
          >
            <li><strong>Firebase</strong></li>
          </ol>
          <p id="b8f57c69-1da3-4f51-bfc0-740e2185f515" class="">
            In unserer App verwenden wir den Dienst Firebase der (Google LLC,
            1600 Amphitheatre Parkway, Mountain View, CA 94043, USA bzw. in
            Europa: Google Ireland Limited, Gordon House, Barrow Street Dublin
            4, Irland (nachfolgend: <strong>Google Firebase</strong>).
          </p>
          <p id="11f46ffe-c346-4739-a279-af1d78018177" class="">
            Wir verwenden die Funktionen Google Analytics for Firebase, Firebase
            Cloud Messaging und Firebase Crashlytics.
          </p>
          <p id="9b08638f-1f6b-4963-a641-74c00f51a7ec" class="">
            <strong>Google Analytics</strong> for Firebase sammelt Daten, mit
            denen wir verstehen können, wie unsere App und ihre Funktionen
            genutzt werden, damit wir unsere Services verbessern können. Wenn
            Sie unsere App nutzen, wird eine Verbindung zu Servern von Google
            Firebase aufgebaut, sodass die Werbe-ID Ihres Endgeräts übertragen
            wird, anhand derer die Auswertung stattfindet. Nähere Informationen
            zur Datenerhebung durch Google finden Sie unter:
            <a href="https://support.google.com/firebase/answer/6318039"
              >https://support.google.com/firebase/answer/6318039</a
            >.
          </p>
          <p id="7a7aaaeb-a093-4ea5-b88c-77a3a6d38aaf" class="">
            Wir können lediglich statistische Informationen einsehen und eine
            Identifizierung ist uns nicht möglich. Zur Speicherdauer von Google
            Analytics for Firebase finden Sie Informationen unter:
            <a href="https://firebase.google.com/support/privacy"
              >https://firebase.google.com/support/privacy</a
            >.
          </p>
          <p id="1f0ef5b2-2e60-4ae3-abeb-505ea9cd550a" class="">
            Rechtsgrundlage für die Verwendung von Google Analytics for Firebase
            ist Art. 6 Abs. 1 S. 1 lit. a DSGVO. Ihre Einwilligung in die
            Datenverarbeitung erfolgt freiwillig und Sie können die Einwilligung
            jederzeit mit Wirkung für die Zukunft widerrufen.
          </p>
          <p id="51d2aae9-6c30-4cc5-b62f-211f6b08402d" class="">
            Sie können jederzeit selbst in den Einstellungen Ihres Endgeräts
            steuern, wie die Werbe-ID verwendet wird (unter iOS unter:
            Einstellungen / Datenschutz / Werbung / Ad-Tracking beschränken und
            unter Android: Einstellungen / Konto / Google / Anzeigen).
          </p>
          <p id="215cdaac-f799-4b78-b45b-f3014d77726b" class="">
            <strong>Firebase Cloud Messaging</strong>
          </p>
          <p id="2df8725f-b8ea-4d1a-bc35-a20ec403a2ce" class="">
            Mit Firebase Cloud Messaging können wir Push-Nachrichten, auch
            In-App-Messages genannt, übermitteln. Diese Nachrichten werden nur
            während der Nutzung unserer Dienste innerhalb der App angezeigt. Die
            Rechtsgrundlage für die Verwendung von Google Analytics for Firebase
            ist Art. 6 Abs. 1 S. 1 lit. f DSGVO, da es unseren berechtigten
            Interessen entspricht, einen Dienstleister für die
            App-Notifikationen einzubinden.
          </p>
          <p id="7fab853e-34c7-4561-a1fd-52d21cdaa79f" class="">
            <strong>Firebase Crashlytics</strong>
          </p>
          <p id="cbd1ec4d-3fd1-4328-8a67-c8a2240e505b" class="">
            Wir nutzen die Funktion Firebase Crashlytics, welche im Falle eines
            App-Absturzes über Cookie-ähnliche Technologien Informationen an die
            Google-Server in den USA überträgt. Hierzu gehören Informationen
            über das verwendete Endgerät und die Verwendung innerhalb der App,
            z.B. der Zeitpunkt, zu dem die App gecrasht ist. Rechtsgrundlage für
            die Verwendung von Firebase Crashlytics ist Art. 6 Abs. 1 S. 1 lit.
            a DSGVO. Ihre Einwilligung in die Datenverarbeitung erfolgt
            freiwillig und Sie können die Einwilligung jederzeit mit Wirkung für
            die Zukunft widerrufen.
          </p>
          <p id="26d67ba1-8c21-4e65-8b3d-2f8ca0ac47c5" class="">
            Eine detaillierte Übersicht über die von Google Firebase erfassten
            Daten finden Sie unter:
            <a href="https://support.google.com/firebase/answer/6318039?hl=de"
              >https://support.google.com/firebase/answer/6318039?hl=de</a
            >.
          </p>
          <p id="bac106ae-f7bb-4cf0-bacd-d9199174535d" class="">
            Weitere Informationen zu Google Firebase finden Sie unter:
          </p>
          <p id="d53078b5-6215-400e-bc77-0e0655e2a9b8" class="">
            <a href="https://firebase.google.com/"
              >https://firebase.google.com/</a
            >
          </p>
          <p id="cc125ef7-2f76-485b-908b-a08e76dd996c" class="">
            <a href="https://www.firebase.com/terms/privacy-policy.html"
              >https://www.firebase.com/terms/privacy-policy.html</a
            >
          </p>
          <p id="0e5934d4-5edd-42c2-8d3a-b1581b024323" class="">
            Die Datenübertragung in die USA wird auf die
            Standardvertragsklauseln der EU-Kommission gestützt.
          </p>
          <p id="a866fe58-73f9-4393-95e7-157273f36f14" class="">
            Details finden Sie hier:
          </p>
          <p id="f4de0e15-ed35-4d45-9154-79d8096fd637" class="">
            <a
              href="https://privacy.google.com/businesses/controllerterms/mccs/"
              >https://privacy.google.com/businesses/controllerterms/mccs/</a
            >.
          </p>
          <ol
            type="1"
            id="72ab9fe5-1493-4ab6-a444-e82176eff6ba"
            class="numbered-list"
            start="6"
          >
            <li><strong>Google Maps</strong></li>
          </ol>
          <p id="5d7d4efc-8f12-4c74-b595-a73c1040a5ad" class="">
            In unsere App ist der Kartendienst Google Maps (Google LLC, 1600
            Amphitheatre Parkway, Mountain View, CA 94043, USA bzw. in Europa:
            Google Ireland Limited, Gordon House, Barrow Street Dublin 4,
            Irland) eingebunden (im Folgenden: „<strong>Google Maps</strong>“
            oder “<strong>Google</strong>”). Wir nutzen den Dienst, damit Sie
            uns schnell verorten und ggf. Ihre Anreise zu uns planen können.
          </p>
          <p id="390cda69-694e-466d-a77f-cb272111b29f" class="">
            Wenn Sie die Standortabfrage zulassen, kann es sein, dass Ihre
            IP-Adresse auf Google-Server in die USA übertragen wird, da
            automatisch eine Verbindung zu Servern von Google aufgebaut wird.
            Neben der IP-Adresse kann es sein, dass Google Maps Datum und
            Uhrzeit des Abrufs oder weitere Metadaten unserer App erhält; ferner
            kann es sein, dass Google Geräte-IDs, Cookie-Informationen und
            Standortinformationen zu verschiedenen Zwecken verarbeitet. Falls
            Sie bei einem Google-Dienst angemeldet sind, kann es sein, dass
            Google diese Daten Ihrem Konto zuordnet (wir haben darauf keinen
            Einfluss).
          </p>
          <p id="5fbbc415-b17c-41ba-b017-f8655d1eca35" class="">
            Informationen dazu, wie Google Standortinformationen verwendet,
            finden Sie unter:
            <a
              href="https://policies.google.com/technologies/location-data#why-use"
              >https://policies.google.com/technologies/location-data#why-use</a
            >. Allgemeine Informationen zum Datenschutz bei Google finden Sie
            unter:
            <a href="https://policies.google.com/privacy?hl=de"
              >https://policies.google.com/privacy?hl=de</a
            >.
          </p>
          <p id="fbbf34ff-3d8c-4253-b404-aadb628599d7" class="">
            <strong>Inkognito-Modus</strong>: Wenn Sie auf Ihrem Endgerät die
            App Google Maps installiert haben und dort den Inkognito-Modus
            ausgewählt haben, werden einige Dienste von Google Maps deaktiviert.
            Dies kann auch die Nutzung von Google Maps auf unserer Seite
            betreffen. Mehr Informationen zum Inkognito-Modus finden Sie unter:
          </p>
          <p id="bc59c64a-637d-48ad-9c99-c1425b1c1f73" class="">
            <a
              href="https://support.google.com/maps/answer/9430563?co=GENIE.Platform%3DiOS&amp;hl=de&amp;oco=0"
              >https://support.google.com/maps/answer/9430563?co=GENIE.Platform%3DiOS&amp;hl=de&amp;oco=0</a
            >
            (iPhone/iPad) und
            <a
              href="https://support.google.com/maps/answer/9430563?co=GENIE.Platform%3DAndroid&amp;hl=de"
              >https://support.google.com/maps/answer/9430563?co=GENIE.Platform%3DAndroid&amp;hl=de</a
            >
            (Android).
          </p>
          <p id="8a0b92b5-4b7f-4f3d-8005-5a71df4fb49f" class="">
            Rechtsgrundlage für die Einbindung von Google Maps und ggf.
            Übermittlung Ihrer Daten an Google ist Art. 6 Abs. 1 S. 1 lit. f
            DSGVO. Zwischen uns und Google Maps besteht eine Vereinbarung über
            die gemeinsame Verantwortlichkeit gem. Art. 26 DSGVO. Diese können
            Sie abrufen unter:
            <a
              href="https://privacy.google.com/intl/de/businesses/mapscontrollerterms/"
              >https://privacy.google.com/intl/de/businesses/mapscontrollerterms/</a
            >.
          </p>
          <p id="c4fe8821-057e-4112-8033-9191beb03c37" class="">
            Die Datenübertragung in die USA wird auf die
            Standardvertragsklauseln der EU-Kommission gestützt.
          </p>
          <p id="9ead8983-85e0-47ad-bd45-c3840e82949a" class="">
            Details finden Sie hier:
          </p>
          <p id="3e41cabb-1f6a-4ba6-9c10-efca56ae1dc7" class="">
            <a
              href="https://privacy.google.com/businesses/controllerterms/mccs/"
              >https://privacy.google.com/businesses/controllerterms/mccs/</a
            >.
          </p>

          <h2>14. Newsletter mit Klick-Tipp</h2>
          <p id="6afaead1-82f6-4f6a-8a36-d830f34193cf" class="">
            Wir bieten Ihnen in unserer App an, dass Sie sich kostenfrei für
            unseren Newsletter anmelden. Wir benötigen hierfür neben Ihrer
            Einwilligungserklärung Ihre E-Mail-Adresse. Weitere Angaben, z.B.
            die Angabe Ihres Namens, sind freiwillig und dienen dazu, Sie
            persönlich anzusprechen.
          </p>
          <p id="559e87af-5dce-464a-8ef0-c441b8cdb9f7" class="">
            Wir werden Ihnen erst dann den Newsletter zusenden, wenn Sie uns
            zuvor Ihre Anmeldung über eine Ihnen zu diesem Zweck zugesandte
            Bestätigungs-E-Mail durch Klicken des dafür vorgesehenen Links
            bestätigen (Double-Opt-In-Verfahren). Damit möchten wir
            sicherstellen, dass nur Sie selbst sich zum Newsletter anmelden
            können. Ihre diesbezügliche Bestätigung muss zeitnah nach Erhalt der
            Bestätigungs-E-Mail erfolgen, da andernfalls Ihre
            Newsletter-Anmeldung automatisch aus unserer Datenbank gelöscht
            wird.
          </p>
          <p id="202168dc-9487-4675-b826-46ae1258606c" class="">
            Die <strong>Rechtsgrundlage</strong> für den Newsletter-Versand
            sowie für die Verarbeitung Ihrer im Zuge der Newsletter-Anmeldung
            freiwilli getätigten weiteren Angaben ist Art. 6 (1) lit. a DSGVO.
            Mit dem Absenden der Newsletter-Anmeldung stimmen Sie der
            Verarbeitung Ihrer Daten durch uns zu. Zusätzlich speichern wir im
            Rahmen Ihrer Newsletter-Anmeldung den Zeitpunkt (Datum und Uhrzeit)
            der Übermittlung Ihrer Daten an uns, sowie Ihre IP-Adresse. Die
            Verarbeitung dieser Daten entspricht unserem berechtigten Interesse
            gem. Art. 6 (1) lit. f DSGVO, um die Sicherheit unserer Systeme zu
            gewährleisten und Missbrauch entgegenzuwirken.
          </p>
          <p id="2376ca31-e965-49e2-9589-81c70c96435b" class="">
            Ihre Daten werden ausschließlich im Zusammenhang mit dem Versand von
            Newslettern verarbeitet. Zweck der Verarbeitung Ihrer E-Mail-Adresse
            ist die Möglichkeit, Ihnen den Newsletter zustellen zu können.
            Weitere Daten im Rahmen des Anmeldevorgangs dienen entweder dazu,
            Sie persönlich anzusprechen oder auch die Sicherheit unserer Dienste
            zu gewährleisten und einen Missbrauch der verwendeten E-Mail-Adresse
            zu verhindern.
          </p>
          <p id="b90328ca-b7af-40db-bfac-0e1df7c8ec67" class="">
            Ihre Daten werden nur so lange gespeichert, wie es für die
            Erreichung des Zwecks notwendig ist. Ihre E-Mail-Adresse wird daher
            über den Zeitraum Ihres aktiven Newsletter-Abonnements gespeichert,
            wenn Ihre Einwilligung hierfür vorliegt. Die Daten, die wir während
            Ihrer Anmeldung zusätzlich automatisch erheben (IP-Adresse, Datum
            und Uhrzeit), werden spätestens gelöscht, wenn Sie Ihre
            Newsletter-Abonnement beenden.
          </p>
          <p id="c1867849-dd09-4356-90a8-5278736bb5b2" class="">
            <strong>Widerspruchsmöglichkeit / Newsletter abbestellen</strong>
          </p>
          <p id="2a717f11-2317-44a6-8c55-af58a622750a" class="">
            Sie können unseren Newsletter jederzeit
            <strong>abbestellen</strong> bzw. <strong>kündigen</strong>. Den
            Link dazu finden Sie am Ende jeden Newsletters. Hierdurch widerrufen
            Sie Ihre Einwilligung bzw. widersprechen einer weiteren Verwendung
            Ihrer Daten zum Zwecke des Newsletter-Versands.
          </p>
          <p id="a6c1debe-cc34-4ec0-b6ea-5afa0a09753c" class="">
            <strong>Newsletterversand und -auswertung mit Klick-Tipp</strong>
          </p>
          <p id="0eb08452-077e-4764-976d-94e6c548e84e" class="">
            Um unsere Newsletter zu versenden, setzen wir den Dienst Klick-Tipp
            der KLICK-TIPP Limited, 15 Cambridge Court, 210 Shepherd’s Bush
            Road, London W6 7NJ, Vereinigtes Königreich (nachfolgend:
            <strong>Klick-Tipp</strong>), ein. Für das Vereinigte Königreich hat
            die Europäische Kommission am 28. Juni 2021 einen
            Angemessenheitsbeschluss erlassen. Dieser ist abrufbar unter:
            <a
              href="https://ec.europa.eu/info/law/law-topic/data-protection/international-dimension-data-protection/adequacy-decisions_en"
              >https://ec.europa.eu/info/law/law-topic/data-protection/international-dimension-data-protection/adequacy-decisions_en</a
            >.
          </p>
          <p id="08b281fa-2970-43d0-8150-2b4a42ce14b7" class="">
            Bei unserem Newsletter-Versand nehmen wir eine Auswertung des
            Nutzerverhaltens vor. Hierfür nutzen wir so genannte Web-Beacons
            bzw. Tracking-Pixel, also kurze Code-Zeichen, die auf unsere Website
            verlinken. Dies funktioniert über eine Zuordnung der durch Erhebung
            in Ziffer 2a genannter Daten mit Web-Beacons, die Ihrer
            E-Mail-Adresse zugeordnet und mit einer eigenen ID verknüpft werden.
            Auch in unseren Newslettern enthaltene Links haben diese ID.
          </p>
          <p id="93e10e83-bf8e-4dcf-9d48-01a9201fd0ff" class="">
            Die Daten werden ausschließlich pseudonymisiert erhoben, so dass die
            IDs nicht mit Ihren personenbezogenen Daten verknüpft werden und ein
            Personenbezug ausgeschlossen ist. Wir erstellen mit den Daten
            Statistiken für die Verbesserung unserer Angebote und Leistungen.
          </p>
          <p id="126a2326-28eb-4479-8aa7-4a6b0308424c" class="">
            Rechtsgrundlage für das Newsletter-Tracking ist Art. 6 Abs. 1 lit. a
            DSGVO (Newsletter-Einwilligung).
          </p>
          <p id="e9ef16d2-6543-4111-899c-ed6efa4eb16f" class="">
            Sie können einem Tracking jederzeit widersprechen, indem Sie den
            gesonderten Abmelde-Link, der in jeder Newsletter-E-Mail
            bereitgestellt wird, anklicken oder uns über die unter Ziffer 1
            genannten Kontaktwege anschreiben.
          </p>
          <p id="2152d4e4-223c-491d-ac60-c4b7ff31a80a" class="">
            Ein solches Tracking ist eingeschränkt, wenn Sie in Ihrem
            E-Mail-Programm die Anzeige von Bildern standardmäßig deaktiviert
            haben. In diesem Fall wird Ihnen der Newsletter jedoch nicht
            vollständig angezeigt und Sie können eventuell nicht alle Funktionen
            nutzen. Wenn Sie die Bilder manuell anzeigen lassen, erfolgt das
            oben genannte Tracking. Ein Tracking über Links wird dann
            ausgeführt, wenn Sie direkt von der E-Mail-Aus auf die Links in den
            Newslettern klicken.
          </p>
          <p id="1ad058ae-3262-4818-a57d-97a8e0f48071" class="">
            Die Datenschutzinformationen von Klick-Tipp finden Sie unter:
            <a href="https://www.klick-tipp.com/datenschutzerkl%C3%A4rung"
              >https://www.klick-tipp.com/datenschutzerklärung</a
            >.
          </p>

          <h2>15. Cookies</h2>
          <p id="133f6af6-ee6d-4cc1-8d0f-bdf9dde129c2" class="">
            Unsere App setzt keine Cookies. Sollte sich dies ändern, wird unsere
            Datenschutzinformation entsprechend angepasst und falls für
            bestimmte Datenverarbeitungen über Cookies Ihre Einwilligung
            erforderlich sein sollte, nehmen wir die Verarbeitung erst nach
            Erteilung einer entsprechenden Einwilligung vor.
          </p>
          <h2>16. Inanspruchnahme von Dienstleistern</h2>
          <p id="f2347f8c-3e5e-4e8f-9759-f5733aec6207" class="">
            Wir möchten darauf hinweisen, dass wir ggf. bei der Verarbeitung
            Ihrer personenbezogener Daten Dienstleister einsetzen (und
            personenbezogene Daten an diese übermitteln), mit denen wir
            Auftragsverarbeitungsverträge abgeschlossen haben (z.B.
            Hosting-Anbieter; Anbieter für die technische Umsetzung von
            Anmeldung/Registrierung, Anbieter für die technische Umsetzung der
            Kursverwaltung). Sofern Auftragsverarbeiter in einem Drittstaat
            (nicht innerhalb der EU) die Datenverarbeitung vornehmen, stellen
            wir sicher, dass das durch die DSGVO gewährleistete Schutzniveau
            Ihrer Daten nicht untergraben wird (Art. 44 ff. DSGVO).
            Rechtsgrundlage für den Einsatz von Dienstleistern und damit
            verbundene Datenverarbeitung ist Art. 6 Abs. 1 S. a, 1 lit. b oder f
            DSGVO. Die Beauftragung von Dienstleistern (Spezialisten oder
            sonstige Leistungserbringer in Bereichen, die wir nicht selbst
            bedienen können) entspricht unserem berechtigten Interesse. Falls
            Sie eine Kopie der geeigneten oder angemessenen Garantien erhalten
            möchten, teilen Sie uns dies gerne (s.o. Ziff. 1) mit.
          </p>
          <h2>17. Ihre Rechte</h2>
          <p id="441c0746-c402-4d93-b6e5-5fd35bca2dc8" class="">
            Wenn wir Ihre Daten verarbeiten, sind Sie „Betroffener“ im Sinne der
            DSGVO. Ihnen stehen folgende Rechte zu:
            <strong>Auskunftsrecht</strong>, Recht auf
            <strong>Berichtigung</strong>, Recht auf
            <strong>Einschränkung</strong> der Verarbeitung, Recht auf
            <strong>Löschung</strong>, Recht auf
            <strong>Unterrichtung</strong> sowie Recht auf
            <strong>Datenübertragbarkeit</strong>. Darüber hinaus haben Sie ein
            <strong>Widerspruchsrecht</strong> und ein
            <strong>Widerrufsrecht</strong> und das Recht, sich bei der
            <strong>Aufsichtsbehörde</strong> zu beschweren.
          </p>
          <p id="fb138966-15be-4c21-88fd-ac0b43ecdbc3" class="">
            Im Folgenden finden Sie einige Details zu den einzelnen Rechten:
          </p>
          <p id="573a90da-368f-482f-bd02-bfabf194f436" class="">
            <strong>a) Auskunftsrecht</strong>
          </p>
          <p id="64f5e03c-0ae1-4b91-80b0-d67da1a1236d" class="">
            Sie haben das Recht, von uns eine Bestätigung darüber zu verlangen,
            ob wir Ihre personenbezogenen Daten verarbeiten. Sofern wir Ihre
            personenbezogenen Daten verarbeiten, haben Sie das Recht,
            insbesondere Auskunft über Verarbeitungszwecke, Kategorien
            personenbezogener Daten, Empfänger oder Empfängerkategorien, ggf.
            Speicherdauer zu erhalten.
          </p>
          <p id="36f8d86b-392e-46e3-8767-bfebc3998cf6" class="">
            <strong>b) Berichtigungsrecht</strong>
          </p>
          <p id="20160a33-515a-47c9-8242-021813955418" class="">
            Sie haben das Recht auf Berichtigung und/oder Vervollständigung der
            Daten, die wir über Sie gespeichert haben, wenn diese Daten
            unrichtig oder unvollständig sind. Wir nehmen die Berichtigung oder
            Vervollständigung unverzüglich vor.
          </p>
          <p id="5cb90f22-364c-4c34-934e-19bdac17b087" class="">
            <strong>c) Recht zur Einschränkung der Verarbeitung</strong>
          </p>
          <p id="06fab44f-8cb3-44a0-92b3-5220c8465faa" class="">
            Unter bestimmten Voraussetzungen haben Sie das Recht, von uns die
            Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu
            verlangen. Ein Beispiel hierfür ist, dass Sie die Richtigkeit Ihrer
            personenbezogenen Daten bestreiten und wir für eine bestimmte Dauer
            die Richtigkeit überprüfen müssen. Für die Dauer der Prüfung werden
            Ihre Daten nur eingeschränkt verarbeitet. Ein anderes Beispiel für
            die Einschränkung ist es, dass wir zwar Ihre Daten nicht mehr
            brauchen, Sie sie aber für einen Rechtsstreit benötigen.
          </p>
          <p id="fb9bf9f3-750a-4aa9-b8ac-e1fc1cf3c041" class="">
            <strong>d) Löschungsrecht</strong>
          </p>
          <p id="f8dffee1-d754-4b5e-ae5c-a8f233195fc7" class="">
            Sie haben in bestimmten Situationen das Recht, von uns zu verlangen,
            dass wir Ihre personenbezogenen Daten unverzüglich löschen. Dies ist
            beispielsweise der Fall, wenn wir Ihre personenbezogenen Daten für
            die Zwecke, für die wir die Daten erhoben haben, nicht länger
            benötigen oder wenn wir Ihre Daten unrechtmäßig verarbeitet haben.
            Ein weiteres Beispiel wäre es, dass wir Ihre Daten aufgrund Ihrer
            Einwilligung verarbeiten, Sie Ihre Einwilligung widerrufen und wir
            die Daten nicht aufgrund einer anderweitigen Rechtsgrundlage
            verarbeiten. Ihr Löschungsrecht besteht aber nicht immer. Es kann
            beispielsweise sein, dass wir Ihre personenbezogenen Daten
            verarbeiten, um einer rechtlichen Verpflichtung nachzukommen oder
            weil wir sie für einen Rechtsstreit benötigen.
          </p>
          <p id="e76367a4-7f5f-436e-8ffe-f3422d93362f" class="">
            <strong>e) Unterrichtungsrecht</strong>
          </p>
          <p id="e77d572d-dbda-4259-be50-18b74384dfa4" class="">
            Wenn Sie Ihr Berichtigungs-, Löschungs- oder Einschränkungsrecht
            gegenüber uns geltend gemacht haben, sind wir dazu verpflichtet,
            allen Empfängern, denen wir Ihre personenbezogenen Daten offengelegt
            haben, die Berichtigung, Löschung oder Einschränkung der
            Verarbeitung Ihrer Daten mitzuteilen, es sei denn, dies erweist sich
            als unmöglich oder ist mit einem unverhältnismäßigen Aufwand
            verbunden.
          </p>
          <p id="47c7b26f-4dbe-455c-b477-0f05af9024a9" class="">
            <strong>f) Recht auf Datenübertragbarkeit</strong>
          </p>
          <p id="c8ac51ff-8ad1-4c0c-9313-a66d3f132340" class="">
            Sie haben unter bestimmten Bedingungen das Recht, die
            personenbezogenen Daten, die Sie uns bereitgestellt haben, in einem
            strukturierten, gängigen und maschinenlesbaren Format zu erhalten
            und das Recht, dass diese Daten einem anderen Verantwortlichen
            übermittelt werden. Das ist dann der Fall, wenn wir die Daten
            entweder aufgrund Ihrer Einwilligung verarbeiten oder aufgrund eines
            Vertrags mit Ihnen und dass wir die Daten mithilfe automatisierter
            Verfahren verarbeiten.
          </p>
          <p id="f26114ce-d09f-4d1e-b209-a5982d943ae8" class="">
            Sie haben dabei das Recht zu erwirken, dass wir Ihre
            personenbezogenen Daten direkt an einen anderen Verantwortlichen
            übermitteln, soweit dies technisch machbar ist und Freiheiten und
            Rechte anderer Personen hierdurch nicht beeinträchtigt werden.
          </p>
          <p id="c7fff3bf-96ee-4ba2-bfe0-82e1f0df7d0a" class="">
            <strong>g) Widerspruchsrecht</strong>
          </p>
          <p id="4fdd552e-2a87-4555-b4eb-6f3b5943cc13" class="">
            Sie haben das Recht, aus Gründen, die sich aus Ihrer besonderen
            Situation ergeben, jederzeit gegen die Verarbeitung Ihrer
            personenbezogenen Daten, die auf von Art. 6 Abs. 1 lit. e oder lit.
            f DSGVO beruht, Widerspruch einzulegen. Dies gilt auch für ein auf
            diese Bestimmungen genanntes Profiling.
          </p>
          <p id="252a6324-e0c9-45f3-a7fa-48d63e4d18de" class="">
            Wir verarbeiten nach einem Widerspruch Ihre personenbezogenen nicht
            mehr, es sei denn, wir können zwingende schutzwürdige Gründe für die
            Verarbeitung nachweisen, die Ihre Interessen, Rechte und Freiheiten
            überwiegen, oder die Verarbeitung dient der Geltendmachung, Ausübung
            oder Verteidigung von Rechtsansprüchen.
          </p>
          <p id="88add611-8859-4074-a8d8-7cf074bf80a7" class="">
            Wenn wir Ihre personenbezogenen Daten verarbeiten, um
            <strong>Direktwerbung</strong> zu betreiben, haben Sie das Recht,
            jederzeit Widerspruch gegen die Verarbeitung Ihrer personenbezogenen
            Daten zum Zwecke derartiger Werbung einzulegen. Dies gilt auch für
            Profiling, soweit es mit der Direktwerbung in Verbindung steht. Wenn
            Sie der Verarbeitung Ihrer personenbezogenen Daten zu Zwecken der
            Direktwerbung widersprechen, werden wir diese nicht mehr für diese
            Zwecke verarbeiten.
          </p>
          <p id="3ffa1d51-0ed5-4c9e-a947-a1f144c804eb" class="">
            <strong>h) Widerrufsrecht</strong>
          </p>
          <p id="9de3164c-4284-4d97-b17b-0e8364da6a25" class="">
            Sie haben gem. Art. 7 (3) DSGVO das Recht, Ihre Einwilligung
            jederzeit zu widerrufen. Durch den Widerruf der Einwilligung wird
            die Rechtmäßigkeit der Verarbeitung nicht rückwirkend unwirksam.
          </p>
          <p id="2bef1863-183f-492c-9d8e-9102fda2f458" class="">
            <strong>i) Beschwerderecht bei einer Aufsichtsbehörde</strong>
          </p>
          <p id="190c5cc2-b131-4be7-891e-dce18aa85ad9" class="">
            Sie haben das Recht auf Beschwerde bei einer Aufsichtsbehörde,
            unbeschadet eines anderweitigen verwaltungsrechtlichen oder
            gerichtlichen Rechtsbehelfs. Sie können insbesondere im
            Mitgliedstaat Ihres Wohnortes, Ihres Arbeitsplatzes oder des Orts
            des mutmaßlichen Verstoßes Ihr Beschwerderecht geltend machen, wenn
            Sie der Ansicht sind, dass die Verarbeitung Ihrer personenbezogenen
            Daten gegen die DSGVO verstößt.
          </p>
          <p id="212f6ddc-6a78-482e-b630-17b8003b4870" class="">
            Eine Übersicht über die jeweiligen Landesdatenschutzbeauftragten der
            Länder sowie deren Kontaktdaten finden Sie unter dem folgenden Link:
          </p>
          <p id="782600ef-9c21-489f-8daa-016e43c746a4" class="">
            <a
              href="https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html"
              >https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html</a
            >.
          </p>

          <h2>18. Aktualität und Änderung dieser Datenschutzbestimmungen</h2>
          <p id="338af78f-63c9-4377-bcb0-4d9327729164" class="">
            Stand: Oktober 2021
          </p>
        </div>
      </article>
    </div>
  </div>
</template>
<script>
export default {
  name: "NewPrivacyLoader",
};
</script>
